import React, { useRef, useState, useEffect } from 'react';

import { ModalProvider, useModalContext } from '@magoosh/context/modal_context';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import SettingsModal from './settings_modal';

export interface Settings {
  compatibilityMode: boolean;
}

interface Props {
  compatibilityMode: boolean;
  onChangeVolume: (volume: number) => void;
  onSave: (settings: Settings) => void;
  onShowSettings?: () => void;
  volume: number;
}

const StimulusControlsAndSettings = (props: Props) => {
  const { setModal } = useModalContext();
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);

  const getVolumeIcon = () => {
    if (props.volume === 0) return 'volume-off';
    if (props.volume < 0.5) return 'volume-down';
    return 'volume-up';
  };

  const handleSave = (settings: Settings) => {
    persistSettingsToUserProfile(settings);
    props.onSave(settings);
    setModal(null);
  };

  const persistSettingsToUserProfile = (settings: Settings) => {
    fetch(paths.api.userProfile(), {
      method: 'PUT',
      body: JSON.stringify({
        userProfile: {
          stimulusCompatibilityMode: settings.compatibilityMode
        }
      })
    });
  };

  const presentSettingsModal = () => {
    props.onShowSettings?.();

    setModal({
      header: 'Audio and Microphone Troubleshooting',
      body: (
        <SettingsModal
          onClose={() => setModal(null)}
          compatibilityMode={props.compatibilityMode}
          onSave={handleSave}
        />
      ),
      onHide: () => handleSave({ compatibilityMode: props.compatibilityMode })
    });
  };

  return (
    <div className="align-self-start d-flex" style={{ width: '100%' }}>
      <div className="align-items-center d-flex gap-xs">
        <div
          className="align-items-center d-flex gap-xs text-gray-light"
          onClick={() => setShowVolumeSlider(!showVolumeSlider)}
          style={{ cursor: 'pointer' }}
        >
          <div className="small">Volume</div>
          <FontAwesomeIcon icon={getVolumeIcon()} style={{ width: 15 }} />
        </div>

        {
          showVolumeSlider && (
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={props.volume}
              onChange={(e) => props.onChangeVolume(Number(e.target.value))}
              style={{ width: 70, cursor: 'pointer' }}
              title={`Volume: ${Math.round(props.volume * 100)}%`}
            />
          )
        }
      </div>

      <div className="d-flex flex-1 gap-xs justify-content-end">
        <a
          className="text-gray-light small text-hover-no-decoration text-no-decoration"
          onClick={presentSettingsModal}
        >
          Trouble hearing/recording?
        </a>
      </div>
    </div>
  );
};

export default (props: Props) => {
  return (
    <ModalProvider>
      <StimulusControlsAndSettings {...props} />
    </ModalProvider>
  );
};
